import { dispatchNotification } from "../../../layouts/app/components/notificationSystem/notifications";

export default class Password {
    static matchPassword(pass, repeat_pass){
         if(pass !== repeat_pass){
             return false;
         }
         return true;
    }

    static isValid(password) {
        let minMaxLength = /^[a-zA-Z0-9.(@#$%^&+=!*"№;:?_,<>|{}[)-]{7,20}/;
        let reg = new RegExp(minMaxLength, 'gi');
        return reg.test(password);
    }

    static ownIsValid(password) {
        let minMaxLength = /^[a-zA-Z0-9.(@#$%^&+=!*"№;:?_,<>|{}[)-]{4,20}/;
        let reg = new RegExp(minMaxLength, 'gi');
        return reg.test(password);
    }

    static getOwnMessageInvalid() {
        return 'Min length is 4 and max length is 20';
    }

    static getMessageInvalid() {
        return 'Min length is 7 and max length is 20';
    }

    _addNotification = () => {
        dispatchNotification({
            message: 'Min length is 7 and max length is 20',
            type: 'error',
            requestTitle: 'Password',
            autoDismiss: 3
        });
    };

    static getMessage(){
        return "Password does not match";
    }
}
